import React from "react";
import Image from "@/bit/components/components.c-image";
import TextInfo, { TEXT_COLOR, TEXT_SEGMENT } from "@/bit/components/components.text";
import Icon from "@/bit/components/components.icon-glyph";

export const COMPONENT_NAME = "TextBlock";

/**
 * Componente que permite crear un bloque de imagenes con un título principal.
 */
const ImageBlock = (props) => {
  const { cmsHandler } = props;
  const imagesList = props["cms-ml-image-block-list-1"];

  return (
    <>
      {cmsHandler && (
        <span
          className={"element-editable block"}
          onClick={cmsHandler
              ? () =>
                  cmsHandler({
                    ...props,
                    name: "cms-block.image-block",
                  })
              : null
          }
        >
          <Icon id="lapiz-m" height={15} color="white" />
        </span>
      )}
      <div className="image-block container">
        <TextInfo
          {...props["cms-atom-text-1"]}
          className="image-block--title"
          cmsHandler={cmsHandler}
        />
        {Array.isArray(imagesList) &&
          imagesList.length > 0 &&
          imagesList.map((item, index) => (
            <div key={index} className="image-block--img-container">
              <Image {...item} objectFit="cover" cmsHandler={cmsHandler} />
            </div>
          ))}
      </div>
      <style jsx>{`.image-block {
  background-color: #ffffff;
  margin-bottom: 1.5rem;
  .image-block--img-container {
    position: relative;
    height: auto;
    :global(.image) {
      position: relative !important;
    }
  }
  :global(.image-block--title) {
    margin: 0.5rem 0 0.5rem 0;
  }
}
`}</style>
    </>
  );
};

export default ImageBlock;
